import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, unref as _unref } from "vue"

const _hoisted_1 = { class: "mainPage XhorizontalCenter" }
const _hoisted_2 = { class: "content XhorizontalCenter" }

import { onMounted, reactive, ref, nextTick } from "vue";
import headComponent from "./head.vue";
import footComponent from "./foot.vue";
import { ElScrollbar } from "element-plus";
import * as api from "@/api";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const pageSrc = reactive({
  log: "页面创建了",
  logo: [] as any,
});

const scrollbarRef = ref<InstanceType<typeof ElScrollbar>>();
onMounted(() => {
  console.log(pageSrc.log);
  getLogo();
});
/**
 * 返回顶部
 */
const toTop = () => {
  (scrollbarRef as any).value.setScrollTop(0);
};
/**
 * 滚动到底部
 */
const scrollToBottom = () => {
  nextTick(() => {
    const scrollbar = scrollbarRef.value;
    if (scrollbar) {
      const wrap = scrollbar.$el?.querySelector(".el-scrollbar__wrap");
      if (wrap) {
        const totalHeight = wrap.scrollHeight;
        const currentTop = wrap.scrollTop;
        const distance = totalHeight - currentTop;
        const duration = 1000; // 增加总持续时间
        const startTime = performance.now();

        const animateScroll = (currentTime: number) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);

          // 使用easeInOutCubic缓动函数：先快后慢
          let easeProgress;
          if (progress < 0.5) {
            // 前半段：快速加速
            easeProgress = 4 * progress * progress * progress;
          } else {
            // 后半段：缓慢减速
            const adjustedProgress = 2 * progress - 2;
            easeProgress =
              0.5 * adjustedProgress * adjustedProgress * adjustedProgress + 1;
          }

          const scrollPosition = currentTop + distance * easeProgress;
          scrollbar.setScrollTop(scrollPosition);

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
      }
    }
  });
};
const getLogo = async () => {
  try {
    const res = await api.getAdImgAndVideo(48);
    pageSrc.logo = res?.data.ad_list[0].pic;
  } catch (e) {
    console.error(e);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElScrollbar), {
    class: "elBar",
    ref_key: "scrollbarRef",
    ref: scrollbarRef
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(headComponent, {
          logo: pageSrc.logo,
          onScrollToBottom: scrollToBottom
        }, null, 8, ["logo"]),
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, { mode: "in-out" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_KeepAlive, null, [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "content_box" }))
                  ])
                ], 1024))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(footComponent, {
          onToTop: toTop,
          logo: pageSrc.logo
        }, null, 8, ["logo"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})